import { ID } from '@/services/common.model'
import { getOrganizationTermsList } from '@/services/terms/terms.service'
import { useRequest } from 'ahooks'
import { Button, Col, Row, Select } from 'antd'
import React, { memo } from 'react'
import TermsModal from '../TermsModal/TermsModal'

interface TermsSelectProps {
  value?: string
  onChange?: (value: string) => void
  orgId: ID
}

export default memo<TermsSelectProps>(function TermsSelect(props) {
  const { value, onChange, orgId } = props
  const { data: termsList = [] } = useRequest(() => getOrganizationTermsList(orgId), {
    ready: !!orgId
  })

  return (
    <Row gutter={16}>
      <Col flex={'auto'}>
        <Select value={value} onChange={onChange}>
          {termsList.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      </Col>
      <Col>
        <Button
          disabled={!value}
          type='primary'
          onClick={() => {
            TermsModal.show({
              terms: termsList.find((item) => item.id === value)!
            })
          }}
        >
          Show
        </Button>
      </Col>
    </Row>
  )
})
